import styled from 'styled-components';

import 'antd/lib/spin/style/index.css';

export const PageTitle = styled.div`
  margin: 0 auto 20px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.headerInline {
    display: flex;
    flex-direction: column;

    span {
      font-size: 18px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.28;
      letter-spacing: 0.01px;
      text-align: left;
      color: #1f5f6f;
      margin-top: 10px;
      display: block;
    }

    p {
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.44;
      letter-spacing: 0.01px;
      text-align: left;
      color: #707070;
    }
  }

  div.headerButtons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    button {
      padding: 0 20px;
      height: 34px;
      border-radius: 3.5px;
      background-color: #1a5f70;
      border: none;
      color: #fff;
      margin-left: 15px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      svg {
        margin-right: 4px;
      }
      &:disabled {
        cursor: not-allowed;
      }
    }
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
  div.noResults {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 350px;
    text-align: center;
    color: #666;
    font-size: 14px;
  }
`;

export const BoxContentHeader = styled.div`
  padding: 10px 30px;
  height: 30px;

  svg {
    color: #dddbdb;
  }

  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 0.01px;
    color: #707070;
  }
`;

export const BoxList = styled.div`
  height: 70px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  margin-top: 15px;

  justify-content: center;
  color: #235f6e;

  div.ant-col {
    line-height: 70px;
    div.n_registro {
      padding-left: 30px;
    }
  }
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      width: 26px;
      min-width: 26px;
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
      }
    }
  }
`;

export const BoxButtonDownload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
`;
